import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from './ProgressBar.module.scss'

const ProgressBar = observer(() => {
  const rootStore = useRootStore()

  const outstandingItems = rootStore.docStore?.cleanupModeStore.outstandingItems
  const cleanedUpItemsCount = rootStore.docStore?.cleanupModeStore.cleanedUpItemsCount || 0
  const percentage = !outstandingItems ? 100 : Math.round((cleanedUpItemsCount * 100) / outstandingItems)

  return (
    <div className={Styles.progressBarContainer}>
      <div className={Styles.progressBar}>
        <div className={Styles.progressBarFillContainer}>
          <div className={Styles.progressBarFill} style={{ width: `${percentage}%` }}></div>
        </div>
      </div>
      <span className={Styles.percentage}>{percentage}%</span>
    </div>
  )
})

export { ProgressBar }
